module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web16.7c8643db.jpg";